import React, { useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Row, Col, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FormInput from "../../../components/FormInput";
import { createBank } from "../../../middleware/backend_hepler";

const CreateBankForm = () => {
    const [loading, setLoading] = useState(false);
    const isLoggedIn = !!localStorage.getItem("isLoggedIn");
    const navigate = useNavigate();

    const methods = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const {
        handleSubmit,
        formState: { errors },
        register,
    } = methods;

    const loanTypeOptions = [
        { value: "personal_loan", label: "Personal Loan" },
        { value: "business_loan", label: "Business Loan" },
        { value: "doctor_loan", label: "Doctor Loan" },
        { value: "home_loan", label: "Home Loan" },
        { value: "mortgage_loan", label: "Mortgage Loan" },
        { value: "nri_loan", label: "NRI Loan" },
    ];

    const onSubmit = async (data) => {
        setLoading(true);

        const selectedLoanTypes = data.selected_loan_types || [];
        const loanTypeStatus = {
            home_loan: selectedLoanTypes.includes("home_loan") ? 1 : 0,
            personal_loan: selectedLoanTypes.includes("personal_loan") ? 1 : 0,
            business_loan: selectedLoanTypes.includes("business_loan") ? 1 : 0,
            mortgage_loan: selectedLoanTypes.includes("mortgage_loan") ? 1 : 0,
            doctor_loan: selectedLoanTypes.includes("doctor_loan") ? 1 : 0,
            nri_loan: selectedLoanTypes.includes("nri_loan") ? 1 : 0,
        };

        const formData = {
            bank_name: data.bank_name.trim(),
            ...loanTypeStatus,
        };

        createBank(formData)
            .then((response) => {
                setLoading(false);
                toast.success("Bank created successfully!");
                setTimeout(() => navigate("/banklist"), 2000);
            })
            .catch((error) => {
                setLoading(false);
                const errorMessage = error.response?.data?.message || error.message;
                console.error("Create bank failed:", errorMessage);

                if (error.response?.status === 409 || errorMessage.includes("Duplicate")) {
                    toast.error("Bank with this name already exists.");
                } else {
                    toast.error("Failed to create bank. Please try again.");
                }
            });

    };

    const handleGoBack = () => {
        if (isLoggedIn) {
            navigate("/banklist");
        } else {
            navigate("/");
        }
    };

    return (
        <div className="container">
            <div className="edit-back-icon">
                <div className="edit-back-text" onClick={handleGoBack}>
                    &lt; Go Back
                </div>
            </div>
            <h2 className="my-4">Bank</h2>
            <FormProvider {...methods}>
                <div className="form-content">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="sections personal-details-sections">
                            <h4>Personal Details</h4>
                            <Row>
                                <Col md={6}>
                                    <FormInput
                                        name="bank_name"
                                        label="Bank Name"
                                        registerOptions={{
                                            required: "Bank Name is required",
                                        }}
                                        error={errors.bank_name?.message}
                                    />
                                </Col>

                            </Row> <Row>
                                <Col md={6}>
                                    <label className="form-label">Loan Types</label>
                                    {loanTypeOptions.map((option) => (
                                        <Form.Check
                                            key={option.value}
                                            type="checkbox"
                                            id={option.value}
                                            label={option.label}
                                            value={option.value}
                                            {...register("selected_loan_types", {
                                                validate: (value) =>
                                                    (value && value.length > 0) || "Loan Type is required",
                                            })}
                                            className="mb-2"
                                        />
                                    ))}
                                    {errors.selected_loan_types && (
                                        <span className="text-danger">
                                            {errors.selected_loan_types.message}
                                        </span>
                                    )}
                                </Col>
                            </Row>

                            <Row className="mt-4">
                                <Col className="text-end">
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        className="custom-submit-button"
                                        disabled={loading}
                                    >
                                        {loading ? "Processing..." : "Submit"}
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </form>
                </div>
            </FormProvider>
            <ToastContainer />
        </div>
    );
};

export default CreateBankForm;
